export default __webpack_public_path__ + "static/media/vehicle_minivan.8844e941.svg";